import React, { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin);
import { NavLink } from "react-router-dom";

import Scrollspy from 'react-scrollspy';

const EducationAndScienceCommunication = () => {
  useEffect(() => {
    

  
  }, [])
  
  return (
    <div className="simple_page">
      <div className="mainIntro">
        <h1>EDUCATION & SCIENCE COMMUNICATION </h1>
        <h3>Cure disease - Secure generations!</h3>
      </div>
      <section className="divider">
        <div className="fixed_sidebar">
          <div className="sidebar">
            <div className="main_sidebar">
              EDUCATION & SCIENCE COMMUNICATION
            </div>
              <Scrollspy
              className="scrollspy" items={['EducationAndScience', 'Reference']}
                currentClassName="active">
              <li><a href="#EducationAndScience">EDUCATION & SCIENCE COMMUNICATION</a></li>
              <li><a href="#Reference">Reference</a></li>
              </Scrollspy>
              
          </div>

        </div>
        <div className="main_lab_style EducationAndScience_page">
          <>
            <p id="EducationAndScience">

              <div className="buttons">
                <div>
                  <a className="main_a" href="https://www.instagram.com/igem_cityu/">
                    <img src="https://static.igem.wiki/teams/4154/wiki/assets/visit1.png" alt="" />
                  </a>
                  <NavLink className="not_main_a" strict exact to="https://www.instagram.com/igem_cityu/" >
                    Visit our Instagram
                  </NavLink>
                </div>
                <div>
                  <a className="main_a" href="https://2022.igem.wiki/cityu-hongkong/comics">
                    <img src="https://static.igem.wiki/teams/4154/wiki/assets/visit2.png" alt="" />
                  </a>
                  <NavLink className="not_main_a choosen" strict exact to='https://2022.igem.wiki/cityu-hongkong/comics' >
                    View our comics
                  </NavLink>
                </div>
                <div>
                  <a className="main_a" href="https://2022.igem.wiki/cityu-hongkong/SynBio">
                    <img src="https://static.igem.wiki/teams/4154/wiki/assets/visit3.png" alt="" />
                  </a>
                  <NavLink className="not_main_a" strict exact to="https://2022.igem.wiki/cityu-hongkong/SynBio" >
                    SynBio Workshop
                  </NavLink>
                </div>
                
              </div>
              <h1>
                EDUCATION & SCIENCE COMMUNICATION

                <br />
              </h1>

              The role of scientists is not limited to merely working behind laboratory doors, but also within the wider community. The SeCure team aspires to dedicate the results of scientific works for the good of the people, and one of the steps we take to achieve that goal is through Education and Science Communication events.
              <br />
              <br />
              These events, especially regarding synthetic biology, are of great importance. A thorough understanding on the topic is needed to ensure that the wider community can form an accurate and complete opinion on the applications of synthetic biology, including our research. The concerns and suggestions from the general public and specific stakeholders who may be affected by a certain synthetic biology project are highly valuable, as it will help researchers to better improve how their projects will positively impact the community. As our project topic also concerns cancer, a debilitating disease which affects people globally, we aim to educate not only inside Hong Kong, but also accessible for communities around the world. 
            </p>
            <br />
            <br />
            <br />
            <br />
            <section id="Reference">
             <p>
              <h1>Reference:</h1>
            </p>
            
            <ol start="1" type="1">
                <li>Chai-lee, G. (2013). The Use of Social Media in Education: A Perspective 2nd International Higher Education Teaching and Learning Conference 2013.
                  Retrieved from: <a target="_blank" href="http://www.curtin.edu.my/tl2013/PDF/The Use of Social Media in Education_ A Perspective.pdf"> http://www.curtin.edu.my/tl2013/PDF/The Use of Social Media in Education_ A Perspective.pdf</a>.
                  Google Scholar
                  </li>
              </ol>
            <p>&nbsp;</p>

           </section>
          </>
        </div>
      </section>
    </div>
  );
}

export default EducationAndScienceCommunication;
